<template>
	<SOSlotBase
		:bg-white="true"
		:loading="pageSetting.loading"
	>
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Detail Konsumen'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-y-8 bg-grey">
				<div class="f-regular f-12 f-c-midgrey">
					Terdaftar sejak {{ $moment(detail.data.terdaftar_raw).format("DD MMM YYYY") }}
				</div>
			</div>

			<SOMenuItemEdit
				:title="'Terdaftar di Outlet'"
				:value="detail.data.nama_outlet"
				class="border-bottom"
				:hide-icon="true"
			/>
			<SOMenuItemEdit
				:title="'Nama'"
				:value="detail.data.nama_customer"
				class="border-bottom"
				:hide-icon="true"
			/>
			<SOMenuItemEdit
				:title="'Jenis Kelamin'"
				:value="detail.data.jenis_kelamin_formated"
				class="border-bottom"
				:hide-icon="true"
			/>
			<SOMenuItemEdit
				:title="'Nomor Telpon'"
				:value="detail.data.telp"
				class="border-bottom"
				:hide-icon="true"
			/>
			<SOMenuItemEdit
				:title="'Tanggal Lahir'"
				:value="detail.data.tanggal_lahir"
				class="border-bottom"
				:hide-icon="true"
			/>
			<SOMenuItemEdit
				:title="'Email'"
				:value="detail.data.email === '' ? '-' : detail.data.email"
				class="border-bottom"
				:hide-icon="true"
			/>

			<div class="separator"></div>

			<SOMenuItemRegular
				:title="'Transaksi SnapClean'"
				:show-subtitle="true"
				:subtitle="formatRupiah(detail.data.jumlah_transaksi.toString()) + ' Transaksi (total)'"
				class="border-bottom"
				@detail="detailTransaksiSnapclean"
			/>

			<div class="separator"></div>

			<SOMenuItemIcon
				:title="'Layanan Terfavorit'"
				:subtitle="'Layanan yang sering digunakan'"
				:show-subtitle="true"
				:icon-favorite="true"
				@action="detailTopFive"
			/>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOMenuItemEdit from "@/so-components/global/ui/SOMenuItemEdit";
import SOMenuItemRegular from "@/so-components/global/ui/SOMenuItemRegular";
import SOMenuItemIcon from "@/so-components/global/ui/SOMenuItemIcon";

export default {
	name: "CustomerGlobalDetail",
	components: {
		SOSlotBase,

		SOLoadingPage,
		SOTitleBar,
		SOMenuItemEdit,
		SOMenuItemRegular,
		SOMenuItemIcon,
	},
	computed: {
		...mapGetters("customerGlobalModule", {
			detail: "getDetailCustomerGlobal",
		})
	},
	data() {
		return {
			idcustomerglobal: "",
			pageSetting: {
				loading: true,

			},
		}
	},
	mounted() {
		this.idcustomerglobal = this.$route.params.idcustomer
		this.getDetail()
	},
	methods: {
		back() {
			// this.$router.push("/konsumen#snapclean")
			this.$router.back()
		},
		async getDetail() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("customerGlobalModule/fetchDetailCustomerGlobal", this.idcustomerglobal)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.back()
			}
		},
		detailTransaksiSnapclean() {
			this.$router.push("/konsumen/snapclean/detail/transaksi/" + this.idcustomerglobal)
		},
		detailPaylink() {
			this.$router.push("/konsumen/snapclean/detail/paylink/" + this.idcustomerglobal)
		},
		detailTopFive() {
			this.$router.push("/konsumen/snapclean/detail/top_five/" + this.idcustomerglobal)
		}
	},
	beforeDestroy() {
		this.$store.commit("customerGlobalModule/resetDetailCustomerGlobal")
	}
}
</script>